import { ListItem, ListItemButton, ListItemIcon, Tooltip } from '@mui/material'
import React from 'react'
import { NavLink } from 'react-router-dom'
import { useStore } from '../../Provider'
import { CollapsedList } from './CollapsedList'
import { SideBarItem } from './SideBarItem'

export const IconButton = (props: SideBarItem): JSX.Element => {
  const { link, icon, text, dataTestId, ariaLabel, disabled, isNested, nestedItems, menuID, isExact = false, isExternal } = props

  const rootStore = useStore()

  const { openState } = rootStore.sidebarStore

  const onClick = (e: React.MouseEvent<HTMLElement>) => {
    if (isNested) e.preventDefault()
  }

  type ExternalProps = { component: 'a'; href: string; target: string; rel: string }
  type InternalProps = { component: typeof NavLink; to: string; exact: boolean; activeClassName: string }
  const buttonProps: ExternalProps | InternalProps = isExternal
    ? { component: 'a', href: link, target: '_blank', rel: 'noopener noreferrer' }
    : { component: NavLink, to: link, exact: isExact, activeClassName: 'iconButton active' }

  return (
    <ListItem key={link} disablePadding aria-label={ariaLabel} data-testid={dataTestId} className='iconButton'>
      <Tooltip
        PopperProps={{ className: 'tooltipStyle' + (isNested ? '' : ' onlyTip') }}
        title={<CollapsedList title={text} sideBarNestedItem={nestedItems} isClick={openState === menuID} />}
        placement='right-start'
      >
        <div className='fullWidthPopper'>
          <ListItemButton {...buttonProps} onClick={onClick} disabled={disabled} disableRipple>
            <ListItemIcon>{icon}</ListItemIcon>
          </ListItemButton>
        </div>
      </Tooltip>
    </ListItem>
  )
}
